<template>
  <v-select
    v-model="timeRange"
    :items="page.ranges"
    label="Plage d'observation"
    outlined
    hide-details
  />
</template>

<script>
import { computed, onMounted, reactive, set } from "@vue/composition-api";
import isEqual from "lodash/isEqual";

import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

export default {
  name: "TimeRangeFilter",
  components: {},
  props: {
    initialValue: {
      type: Number,
      validator(value) {
        return !isNaN(value);
      },
    },
    store: {
      type: String,
      validator(value) {
        /* List of stores having :
        - getters["<store>/<storeGetter>"]
        - dispatch("<store>/<storeUpdater>", payload)
        */
        return ["aiFactory"].includes(value);
      },
    },
    storeGetter: {
      type: String,
      default: "getObservationRange",
    },
    storeUpdater: {
      type: String,
      default: "updateObservationRange",
    },
    noUrl: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { store } = useProxy();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const page = reactive({
      isInitialized: false,
      initialUrlValue: 0, // in case we need to load from url params
      ranges: [
        { value: 1, text: "Dernière heure" },
        { value: 2, text: "2 dernières heures" },
        { value: 4, text: "4 dernières heures" },
        { value: 6, text: "6 dernières heures" },
        { value: 12, text: "12 dernières heures" },
        { value: 24, text: "24 dernières heures" },
        { value: 48, text: "48 dernières heures" },
      ],
    });

    // =>  METHODS

    // =>  COMPUTED
    const viaStore = computed(() => props.store !== undefined);
    const initialValue = computed(() =>
      props.noUrl
        ? props.initialValue
        : page.initialUrlValue ?? props.initialValue
    );

    const timeRange = computed({
      get: () => {
        if (viaStore.value) {
          return store.getters[`${props.store}/${props.storeGetter}`];
        }

        return initialValue.value;
      },
      set: (value) => {
        if (viaStore.value) {
          store.dispatch(`${props.store}/${props.storeUpdater}`, value);

          if (page.isInitialized && !props.noUrl) {
            // Only update user changes, not initialization
            addQueryStringParam({
              param: "timeRange",
              value: value,
              // is_multiple: false,
              is_integer: true,
              // is_boolean: false,
            });
          }
        }

        if (!isEqual(value, initialValue.value)) {
          emit("valueChanged", value);
        }
      },
    });

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      if (viaStore.value && !props.noUrl) {
        set(
          page,
          "initialUrlValue",
          await synchronizeFilterWithQueryString({
            dispatcher: "aiFactory/updateObservationRange",
            param: "timeRange",
            value: timeRange.value,
            // is_multiple: false,
            is_integer: true,
            // is_boolean: false,
            // dependsOn: undefined,
          })
        );
      }

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      page,
      timeRange,
    };
  },
};
</script>

<style></style>
